import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { IoCloseOutline } from "react-icons/io5";
import ModalContext, {
  defaultModalContext,
} from "../../../contexts/ModalContext";
import Glass from "../Glass";
import { Card } from "../Cards";
import ModalBox, {
  ModalWrapper,
  ModalHeader,
  ModalCloseButton,
  ModalCloseIcon,
} from "./Modal.Style";

const Modal = (props) => {
  const {
    action,
    actionText,
    actionProps,
    show: initialShow,
    opacityGlass,
    headerModal,
    footerModal,
    closeIcon,
    onClose,
    onShow,
    onToggle,
    className,
  } = props;

  const [show, setShow] = useState(initialShow);

  const closeHandle = useCallback(
    (evt) => {
      evt.preventDefault();
      if (onClose) {
        onClose(false);
      }
      setShow(false);
    },
    [onClose]
  );

  const showHandle = useCallback(
    (evt) => {
      evt.preventDefault();
      if (onShow) {
        onShow(true);
      }
      setShow(true);
    },
    [onShow]
  );

  const toggleHandle = useCallback(() => {
    if (onToggle) {
      onToggle(show);
    }
  }, [onToggle, show]);

  useEffect(() => {
    toggleHandle();
  }, [show, toggleHandle]);

  useEffect(() => {
    setShow(initialShow);
  }, [initialShow]);

  const header = (
    <ModalHeader>
      {headerModal}
      <ModalCloseButton onClick={closeHandle}>
        <ModalCloseIcon as={closeIcon} />
      </ModalCloseButton>
    </ModalHeader>
  );

  return (
    <ModalContext.Provider
      value={{
        show,
        closeHandle,
        showHandle,
        action,
        actionText,
        actionProps,
      }}
    >
      {action
        ? React.createElement(action, {
            ...actionProps,
            label: actionText,
            onClick: showHandle,
            href: "#",
          })
        : null}
      <Glass show={show} glassOpacity={opacityGlass}>
        <ModalWrapper>
          <ModalBox
            {...props}
            show={show}
            className={`${className || ""}${show ? " active" : ""}`}
            header={header}
            footer={footerModal}
            closeHandle={closeHandle}
            showHandle={showHandle}
            toggleHandle={toggleHandle}
          />
        </ModalWrapper>
      </Glass>
    </ModalContext.Provider>
  );
};

Modal.defaultProps = {
  ...defaultModalContext,
  opacityGlass: Glass.defaultProps.opacity,
  as: Card,
  headerModal: null,
  footerModal: null,
  closeIcon: IoCloseOutline,
};

Modal.propTypes = {
  show: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  action: PropTypes.elementType,
  actionText: PropTypes.string,
  actionProps: PropTypes.instanceOf(Object),
  onToggle: PropTypes.func,
  onShow: PropTypes.func,
  onClose: PropTypes.func,
  opacityGlass: PropTypes.number,
  as: PropTypes.elementType,
  headerModal: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  footerModal: PropTypes.element,
  closeIcon: PropTypes.elementType,
};

export default Modal;
